import React from "react";
import "./WorkflowSection.css";

const steps = [
  {
    number: 1,
    title: "Requirement Discussion",
    description:
      "We understand your business model, challenges and goals to define the right technical solution.",
  },
  {
    number: 2,
    title: "Planning & Design",
    description:
      "Our team creates detailed workflows, UI/UX designs and technical architecture aligned with your needs.",
  },
  {
    number: 3,
    title: "Development",
    description:
      "We develop your web or mobile app using modern, secure and scalable technologies.",
  },
  {
    number: 4,
    title: "Testing & Launch",
    description:
      "Every feature is tested thoroughly to ensure performance, security and reliability before launch.",
  },
  {
    number: 5,
    title: "Ongoing Support",
    description:
      "We provide long-term maintenance, upgrades and technical support to keep your system running smoothly.",
  },
];

const WorkflowSection = () => {
  return (
    <section className="workflow-section">
      <div className="workflow-container">
        <h2>
          Our <span>Workflow</span>
        </h2>

        <div className="workflow-steps">
          {steps.map((step) => (
            <div key={step.number} className="workflow-step">
              <div className="step-number">{step.number}</div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WorkflowSection;
